import { useState, useEffect } from "react";
import AuthenticationDomain from "domainActions/authentication/AuthenticationDomain";
const useActiveBackend = (listenableActions = []) => {
  var _a;
  const [loadActiveResponse, setLoadActiveResponse] = useState();
  const [finishedLoading, setFinishedLoading] = useState(false);
  const _loadActive = () => AuthenticationDomain.loadActive().then((response) => {
    setFinishedLoading(true);
    setLoadActiveResponse(response);
  });
  useEffect(() => {
    _loadActive();
  }, []);
  useEffect(() => {
    const unlistenActions = listenableActions.map((action) => action.completed.listen(_loadActive));
    return () => {
      unlistenActions.forEach((unlistenAction) => unlistenAction());
    };
  }, [listenableActions]);
  return {
    finishedLoading,
    activeBackend: loadActiveResponse == null ? void 0 : loadActiveResponse.backend,
    backendsTotal: (_a = loadActiveResponse == null ? void 0 : loadActiveResponse.context) == null ? void 0 : _a.backendsTotal
  };
};
export default useActiveBackend;
